export default __webpack_public_path__ + "static/media/sunsculpted4.171e80c3.jpg";